import React from 'react';
import { Link } from 'react-router-dom';

const Widget = ({
  id,
  w,
  showFlowEfficiency,
  title,
  customizeMode,
  children,
  linkTo,
  className = '',
  style,
}) => {
  return (
    <div className="grid-stack-item" id={id} style={style}>
      <div className={`cell ${className}`}>
        <div className='cell-header'>
          <h4>{title}</h4>
          {customizeMode && (
            <div className='card-drag'>
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M15.9454 17.8918C16.3087 17.8918 16.5938 18.1771 16.5939 18.5403V21.7844H18.9298C19.5004 21.7847 19.7859 22.4848 19.3839 22.887L14.4659 27.804C14.2065 28.0634 13.8045 28.0634 13.545 27.804L8.62805 22.887C8.21287 22.4848 8.49831 21.7844 9.08215 21.7844H11.4044V18.5403C11.4045 18.1772 11.6897 17.892 12.0529 17.8918H15.9454ZM5.11145 8.62817C5.51365 8.21299 6.21497 8.49842 6.21497 9.08228V11.4045H9.45813C9.82136 11.4045 10.1065 11.6898 10.1066 12.053V15.9456C10.1065 16.3088 9.82139 16.594 9.45813 16.594H6.21497V18.9163C6.21497 19.5001 5.51365 19.7862 5.11145 19.384L0.194458 14.4661C-0.0647671 14.2066 -0.0648822 13.8046 0.194458 13.5452L5.11145 8.62817ZM21.7843 9.08228C21.7843 8.49842 22.4844 8.21299 22.8995 8.62817L27.8165 13.5452C28.063 13.7917 28.0633 14.2069 27.8038 14.4534L22.8868 19.3704C22.4846 19.7855 21.7843 19.5001 21.7843 18.9163V16.594H18.5402C18.177 16.5939 17.8918 16.3088 17.8917 15.9456V12.053C17.8918 11.6898 18.177 11.4046 18.5402 11.4045H21.7843V9.08228ZM13.5323 0.19458C13.7918 -0.064883 14.1938 -0.0649015 14.4532 0.19458L19.3702 5.11157C19.7854 5.51378 19.5 6.21509 18.9161 6.21509H16.5939V9.45825C16.5939 9.82152 16.3087 10.1067 15.9454 10.1067H12.0529C11.6897 10.1066 11.4044 9.82147 11.4044 9.45825V6.21509H9.08215C8.49831 6.21509 8.21315 5.51378 8.61536 5.11157L13.5323 0.19458Z" fill="#004080"/>
              </svg>
            </div>
          )}
        </div>
        {children}
        {linkTo && !customizeMode && <Link className='link' to={linkTo}></Link>}
      </div>
    </div>
  );
};

export default Widget;
